export default __webpack_public_path__ + "static/media/1-Ano-04-Atencao-Aos-Sons.a1459749.png";